import { useCallback } from 'react';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import type { PsfShareChannel } from 'src/app/pages/psf/share/shared/types';
import { pullBandit } from 'src/app/shared/api/bandits';

import { useGetHeadlineVariant } from '../bandits';

export function usePullBandits() {
	const utilityContext = useUtilityContext();
	const getVariant = useGetHeadlineVariant();

	return useCallback(
		async (channel: PsfShareChannel) => {
			switch (channel) {
				case 'facebook':
				case 'whatsapp':
				case 'copy':
				case 'twitter': {
					const variant = getVariant(channel);
					if (variant) {
						const { experimentName, variantName } = variant;
						await pullBandit({ experimentName, variantName }, utilityContext, { silent: true });
					}
					break;
				}
				default:
				// do nothing
			}
		},
		[getVariant, utilityContext],
	);
}
